import React, {useContext, useState} from "react";
import {SoknaderContext} from "./contexts/SoknaderContext";
import {INote} from "./models/Note";
import {Accordion, Button, Card, Form, Modal} from "react-bootstrap";
import moment from "moment";

function SoknadNotes() {

    const {soknadNotes, createNoteFunction, soknad, loadingNotes} = useContext(SoknaderContext);
    const [showModal, setShowModal] = useState(false);
    const [newSubject, setNewSubject] = useState<string|null>();
    const [newBody, setNewBody] = useState<string|null>();

    const handleCloseModal = () => {
        setShowModal(false);
        setNewBody(null);
        setNewSubject(null);

    };
    const handleSendMessage=()=>{
        if ((newSubject && newSubject.length>0) && newBody && newBody.length>0){
            createNoteFunction(newSubject, newBody);
            handleCloseModal();
        }
        else{
            alert("Emne og melding må fylles ut");
        }
    }

    if (soknad?.id===0){
        return null;
    }

    if (loadingNotes) {
        return (
            <div>Laster meldinger...</div>
        )
    }

    return (
        <>
            <Card>
                <Card.Header className={"bg-primary card-header-ext"}>
                    Meldinger
                </Card.Header>
                <Card.Body>
                    <Button onClick={()=>{
                        setShowModal(true);
                    }}>Ny melding</Button>
                   <div className="mt-3">
                       {
                           soknadNotes.length===0?<p>Ingen meldinger å vise...</p>:
                               <Accordion>
                                   { soknadNotes.map((x:INote)=>{
                                       return(
                                           <Accordion.Item eventKey={x.id.toString()} key={x.id}>
                                               <Accordion.Header>{`${moment(x.registered).format("DD.MM.yyyy HH:mm")} - ${x.subject}`}</Accordion.Header>
                                               <Accordion.Body>
                                                   <p style={{whiteSpace: "pre-wrap"}}>
                                                       {x.body}
                                                   </p>
                                               </Accordion.Body>
                                           </Accordion.Item>);
                                   })}
                               </Accordion>
                       }
                   </div>


                </Card.Body>
            </Card>
            <Modal show={showModal} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Skriv ny melding til saksbehandler</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-group row mb-2">
                        <label className="col-md-2 col-form-label col-form-label-sm">Emne</label>
                        <div className="col-md-10">
                            <input
                                type="text"
                                className="form-control form-control-sm"
                                value={newSubject??""}
                                onChange={(e: any) => {
                                    setNewSubject(e.target.value)
                                }}
                            />
                        </div>
                    </div>
                    <div className="form-group row mb-2">
                        <label className="col-md-2 col-form-label col-form-label-sm">Melding</label>
                        <div className="col-md-10">
                            <textarea
                                rows={5}
                                className="form-control form-control-sm"
                                value={newBody??""}
                                onChange={(e: any) => {
                                    setNewBody(e.target.value)
                                }}
                            />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>
                        Avbryt
                    </Button>
                    <Button variant="primary" onClick={handleSendMessage}>
                        Send
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default SoknadNotes